import state from './state'

import mutations from './mutations'

import * as actions from './actions'

import * as actionsSocket from './actions-socket'

import * as getters from './getters'

export default {
  state,
  mutations,
  // eslint-disable-next-line
  actions: Object.assign(actions, actionsSocket),
  getters
}
